import React from 'react';

export interface QuoteOptionCardProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  icon?: React.ReactNode;
  title: string;
  description?: string;
}

export const QuoteOptionCard: React.FC<QuoteOptionCardProps> = ({
  selected = false,
  icon,
  title,
  description,
  className = '',
  ...props
}) => {
  return (
    <button
      type="button"
      aria-pressed={selected}
      className={`group text-left rounded-2xl border p-4 transition-all duration-200 ${
        selected
          ? 'border-brand-500 bg-brand-500/10 shadow-lg shadow-brand-500/10'
          : 'border-slate-700/80 bg-slate-900/45 hover:border-brand-500/60 hover:bg-slate-800/60'
      } ${className}`}
      {...props}
    >
      <span className="flex items-center gap-3">
        {icon && (
          <span
            className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl transition-colors ${
              selected ? 'bg-brand-500/20 text-brand-300' : 'bg-slate-800 text-slate-400 group-hover:text-brand-300'
            }`}
          >
            {icon}
          </span>
        )}
        <span className="min-w-0">
          <span className="block text-sm font-bold text-white">{title}</span>
          {description && <span className="mt-1 block text-xs leading-5 text-slate-400">{description}</span>}
        </span>
      </span>
    </button>
  );
};
